/* global WDPRO, inject:true */
inject = WDPRO.Personalization.inject = WDPRO.Personalization.inject || inject;
inject.store('Personalization', WDPRO.Personalization);
